// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3Cg8B","savePackageButton":"ClientWallet_savePackageButton__1zfQ3"};